export const isProd = () => {
  return location.href.startsWith('https://mobile');
};
